"use client";

import { c as _c } from "react/compiler-runtime";
import { LuClock } from "react-icons/lu";
import { selectMsLeft, useAccessExpiryStore } from "@/stores/access-expiry-store";
const WARN_WITHIN_MS = 14 * 24 * 60 * 60 * 1000;
const DAY_MS = 24 * 60 * 60 * 1000;
const HOUR_MS = 60 * 60 * 1000;
const MINUTE_MS = 60 * 1000;
function pluralize(value: number, unit: string): string {
  return `${value} ${unit}${value === 1 ? "" : "s"}`;
}
function formatTimeLeft(msLeft: number): string {
  if (msLeft <= 0) return "0 minutes";
  const minutes = Math.floor(msLeft / MINUTE_MS);
  const hours = Math.floor(msLeft / HOUR_MS);
  const days = Math.floor(msLeft / DAY_MS);
  if (days >= 2) return pluralize(days, "day");
  if (days === 1) {
    const remainingHours = hours % 24;
    return `1 day, ${pluralize(remainingHours, "hour")}`;
  }
  if (hours >= 1) return pluralize(hours, "hour");
  return pluralize(minutes, "minute");
}
export default function AccessExpiryBanner() {
  const $ = _c(7);
  const msLeft = useAccessExpiryStore(selectMsLeft);
  if (msLeft === null) {
    return null;
  }
  if (msLeft > WARN_WITHIN_MS) {
    return null;
  }
  const isExpired = msLeft <= 0;
  const isUrgent = msLeft <= DAY_MS;
  const tone = isExpired || isUrgent ? "bg-status-error-bg text-status-error-text" : "bg-status-warning-bg text-status-warning-text";
  const t0 = `flex items-center gap-2 px-4 py-2 text-body ${tone}`;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LuClock className="h-4 w-4 shrink-0" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isExpired || $[2] !== msLeft) {
    t2 = isExpired ? <span>Your access to the platform has <strong>expired</strong>. Please reach out to us to restore access.</span> : <span>Your access to the platform expires in{" "}<strong>{formatTimeLeft(msLeft)}</strong>. Please reach out to us if you need more time.</span>;
    $[1] = isExpired;
    $[2] = msLeft;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t0 || $[5] !== t2) {
    t3 = <div className={t0}>{t1}{t2}</div>;
    $[4] = t0;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}